<template>
  <div class="testemunholist">
    <slot></slot>
  </div>
</template>

<script>
export default {
  setup () {
    return {

    }
  }
}
</script>

<style scoped>
.testemunholist{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>